// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

import { transformUserManageConfig } from '../transformers/manage-user';
const UserManageConfig = async (_, args, context) => {
  const {
    userId
  } = args;
  const url = `${context.url.stargateRoot}/users/${userId}/manage`;
  return context.fetch(url).then(data => data.json()).then(data => transformUserManageConfig(data));
};
export default UserManageConfig;